import { useEffect } from 'react';

const BRAND = 'Jarvis';

// The browser tab says where you are ("Time logging · Jarvis"), so several tabs of the portal can be told apart.
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} · ${BRAND}` : BRAND;
    return () => {
      document.title = BRAND;
    };
  }, [title]);
}
